<template>
  <countdown
    class="countdown"
    :time="time"
    :transform="transform"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="props">
      <div
        class="d-flex flex-row justify-content-center align-items-start flex-nowrap"
      >
        <div
          class="countdown-block d-flex flex-column justify-content-center align-items-center"
          v-if="props.days || displayDaysAlways"
        >
          <span class="m-0 p-0">{{ pad2(props.days) }}</span>
          <span v-if="displayUnits" class="unit smallest">
            {{ $tc('GENERAL.LABEL.DAY_TEXT_VARIANT', props.days) }}
          </span>
        </div>
        <span v-if="props.days || displayDaysAlways">:</span>
        <div
          class="countdown-block d-flex flex-column justify-content-center align-items-center"
          v-if="props.hours || props.days > 0 || displayHoursAlways"
        >
          <span class="m-0 p-0">{{ pad2(props.hours) }}</span>
          <span v-if="displayUnits" class="unit smallest">
            {{ $tc('GENERAL.LABEL.HOUR_TEXT_VARIANT', props.hours) }}
          </span>
        </div>
        <span v-if="props.hours || props.days > 0 || displayHoursAlways">
          :
        </span>
        <div
          class="countdown-block d-flex flex-column justify-content-center align-items-center"
          v-if="
            props.minutes ||
            props.days > 0 ||
            props.hours > 0 ||
            displayMinutesAlways
          "
        >
          <span class="m-0 p-0">{{ pad2(props.minutes) }}</span>
          <span v-if="displayUnits" class="unit smallest">
            {{ $tc('GENERAL.LABEL.MINUTE_TEXT_VARIANT', props.minutes) }}
          </span>
        </div>
        <span
          v-if="
            props.minutes ||
            props.days > 0 ||
            props.hours > 0 ||
            displayMinutesAlways
          "
        >
          :
        </span>
        <div
          class="countdown-block d-flex flex-column justify-content-center align-items-center"
        >
          <span class="m-0 p-0">{{ pad2(props.seconds) }}</span>
          <span v-if="displayUnits" class="unit smallest">
            {{ $tc('GENERAL.LABEL.SECOND_TEXT_VARIANT', props.seconds) }}
          </span>
        </div>
      </div>
    </template>
  </countdown>
</template>

<script>
import Vue from 'vue';
import countdown from '@chenfengyuan/vue-countdown';

export default Vue.extend({
  name: 'HMCountdown',
  components: {
    countdown,
  },
  props: {
    date: {
      type: Date,
      required: true,
    },
    displayUnits: {
      type: Boolean,
      default: false,
    },
    displayDaysAlways: {
      type: Boolean,
      default: false,
    },
    displayHoursAlways: {
      type: Boolean,
      default: false,
    },
    displayMinutesAlways: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    time() {
      if (!this.date) return null;
      return new Date(this.date) - Date.now();
    },
  },
  methods: {
    transform(props) {
      props.text = this.getCountdownText(props);
      return props;
    },
    pad2(number) {
      return String(number || 0).padStart(2, '0');
    },
    getCountdownText({
      days,
      totalHours,
      hours,
      totalMinutes,
      minutes,
      totalSeconds,
      seconds,
    }) {
      const daysText = this.$tc('GENERAL.LABEL.DAY_VARIANT', days);
      const hoursText = this.$tc('GENERAL.LABEL.HOUR_VARIANT', hours);
      const minutesText = this.$tc('GENERAL.LABEL.MINUTE_VARIANT', minutes);
      const secondsText = this.$tc('GENERAL.LABEL.SECOND_VARIANT', seconds);
      const startsIn = this.$t('EVENTS.LABEL.STARTS_IN');
      const and = this.$t('GENERAL.LABEL.AND');
      if (totalHours >= 24 && hours)
        return `${startsIn} ${daysText} ${and} ${hoursText}`;
      else if (totalHours >= 24) return `${startsIn} ${daysText}`;
      else if (totalHours)
        return `${startsIn} ${hoursText} ${and} ${minutesText}`;
      else if (totalMinutes)
        return `${startsIn} ${minutesText} ${and} ${secondsText}`;
      else if (totalSeconds) return `${startsIn} ${secondsText}`;
      else return this.$t('EVENTS.TEXT.EVENT_WAITING_TO_START');
    },
  },
});
</script>

<style lang="scss" scoped>
.unit {
  line-height: 26px;
}
.countdown-block {
  min-width: 2rem;
}
</style>
